import React from 'react';
import { Link } from '@hpstellar/core/visId';
import { Truck, StarCircle } from '@hpstellar/veneer-icons';

import useDeviceInfo from '../../../hooks/useDeviceInfo';
import { useRewardsModalState } from '../../../hooks/useCartState';

import './link-group.less';

export default ({ shippingInfoLink = '/us-en/shop/cv/shippingpolicy' }) => {
    const { device } = useDeviceInfo(['device'], 'default');
    const { setRewardsModalState, isLoyaltyProductPresent, isLoyaltyEnrolled } = useRewardsModalState(true);

    if (device !== 'mobile') {
        return null;
    }

    return (
        <div className="link-group">
            <div className="link-group-row">
                <Truck size={16} />
                <Link
                    to={shippingInfoLink}
                    target="_blank"
                    rel="noopener"
                    theme="dark"
                    children="Shipping and delivery"
                />
            </div>
            {isLoyaltyProductPresent && !isLoyaltyEnrolled && (
                <div className="link-group-row">
                    <StarCircle size={16} />
                    <Link
                        asButton
                        onClick={() => {
                            setRewardsModalState();
                        }}
                        theme="dark"
                        children="Join HP Rewards"
                    />
                </div>
            )}
        </div>
    );
};
